import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/base-components';
import { cx, FOCUS_RING } from '../components/styles';
import { CONTAINER, CTA_MICROCOPY } from './landingConfig';
import { Reveal } from './Reveal';
import { useLandingCtas } from './useLandingCtas';

/** Section 10 — the second-highest-clicked CTA on any landing page. */
export const CtaBand: React.FC = () => {
  const { primary, signedIn } = useLandingCtas();
  return (
  <Reveal as="section" className="relative overflow-hidden border-y border-white/[0.06]">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          'radial-gradient(60% 120% at 50% 0%, rgba(59,130,246,0.08) 0%, rgba(59,130,246,0) 70%)',
      }}
    />
    <div className={cx(CONTAINER, 'relative flex flex-col items-center py-20 text-center lg:py-24')}>
      <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
        Ready to stop switching tabs?
      </h2>
      <p className="mt-4 max-w-xl text-white/60">
        Connect your first account in under five minutes.
      </p>
      <Link to={primary.to} className={cx('mt-8 rounded-lg', FOCUS_RING)}>
        <Button size="lg" whitespace="nowrap">
          {primary.label}
        </Button>
      </Link>
      {!signedIn && <p className="mt-4 text-xs text-white/40">{CTA_MICROCOPY}</p>}
    </div>
  </Reveal>
  );
};
